import { AnySchema, ValidationError } from 'yup'
import EmploymentHistoryValidator from '../../../validators/EmploymentHistoryValidator'
import { EmploymentHistoryEntry } from './EmploymentHistoryContext'

export const validateEntry = (
  entry : EmploymentHistoryEntry,
  validateSituation = false,
  validateEmployerDetails = false,
  validateTimeInSituation = false,
  expectTimeInSituationInEmployerDetails = false
) : ValidationError[] | boolean => {
  const employmentSituationSchema = EmploymentHistoryValidator
    .EmploymentSituationValidator()
    .getValidator()
  const employmentDetailsSchema = EmploymentHistoryValidator
    .EmploymentDetailsValidator(expectTimeInSituationInEmployerDetails)
    .getValidator()
  const employmentLengthOfTimeSchema = EmploymentHistoryValidator
    .LengthOfTimeValidator()
    .getValidator()

  let schema : AnySchema | undefined
  if (validateSituation) {
    schema = employmentSituationSchema
  }
  if (validateEmployerDetails) {
    schema = schema === undefined ? employmentDetailsSchema : schema.concat(employmentDetailsSchema)
  }
  if (validateTimeInSituation) {
    schema = schema === undefined ? employmentLengthOfTimeSchema : schema.concat(employmentLengthOfTimeSchema)
  }

  if (schema === undefined) return false

  try {
    schema.validateSync({
      employmentSituation: entry?.employmentSituation?.toLowerCase(),
      jobTitle: entry?.employerDetails?.jobTitle,
      companyName: entry?.employerDetails?.companyName,
      location: entry?.employerDetails?.location,
      years: entry?.lengthOfTime?.years,
      months: entry?.lengthOfTime?.months
    }, { abortEarly: false })
    return true
  } catch (e) {
    const validationError = e as ValidationError
    if (!validationError.inner) return false
    return validationError.inner
  }
}

export const isValidCompleteEntry = (entry : EmploymentHistoryEntry) : boolean => {
  const validationErrors = validateEntry(
    entry,
    true,
    true,
    true,
    false
  )
  return validationErrors === true
}
